import { render } from "./PodcastManagement.vue?vue&type=template&id=6ebb68b8&scoped=true"
import script from "./PodcastManagement.vue?vue&type=script&lang=js"
export * from "./PodcastManagement.vue?vue&type=script&lang=js"

import "./PodcastManagement.vue?vue&type=style&index=0&id=6ebb68b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebb68b8"]])

export default __exports__